import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material';

// Import your components
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import AdminDashboard from './components/AdminDashboard';
import TemplateManagement from './components/Admin/TemplateManagement';
import SurveyPage from './components/SurveyPage';
import Solutions from './components/Solutions';
import Resources from './components/Resources';
import Partners from './components/Partners';
import ContactUsPage from './components/ContactUsPage';
import SurveyDashboard from './components/SurveyDashboard';
import TemplateView from './components/TemplateView';
import ReportPage from './components/ReportPage';
import IncidentManagementPage from './components/IncidentManagementPage';
import ArchivedPage from './components/Admin/ArchivedPage';
import TemplateCreate from './components/TemplateCreate';
import UserGuide from './components/Template/UserGuide';
import PreviewSurvey from './components/Admin/PreviewSurvey';

// Import Montserrat font
import '@fontsource/montserrat'; // Optional, if installed via npm

// Create a theme with Montserrat as the global font
const theme = createTheme({
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    h1: { fontFamily: "'Montserrat', sans-serif" },
    h2: { fontFamily: "'Montserrat', sans-serif" },
    body1: { fontFamily: "'Montserrat', sans-serif" },
    body2: { fontFamily: "'Montserrat', sans-serif" },
  },
  palette: {
    primary: {
      main: '#1E2742', // Dark Blue
    },
    secondary: {
      main: '#FF6F61', // Example secondary color
    },
    background: {
      default: '#F5F5F5', // Light background
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box
          sx={{
            color: theme.palette.text.primary, // Use text color from theme
            fontFamily: theme.typography.fontFamily, // Global font
            height: '100vh', // Ensure full height
          }}
        >
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/contact" element={<ContactUsPage />} />

            {/* Admin Routes */}
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/templates" element={<TemplateManagement />} />
            <Route path="/admin/archive" element={<ArchivedPage />} />
            <Route path="/admin/survey/:surveyId" element={<SurveyDashboard />} />
            <Route path="/admin/temp-view/:templateId" element={<TemplateView />} />
            <Route path="/admin/templates/create" element={<TemplateCreate />} />
            <Route path="/admin/guide" element={<UserGuide />} />
            <Route path="/preview/:surveyId" element={<PreviewSurvey />} />

            {/* Survey Routes */}
            <Route path="/survey/:surveyId/:participantId" element={<SurveyPage />} />
            <Route path="/survey/report/:surveyId" element={<ReportPage />} />
            <Route path="/survey/incident-management/:surveyId" element={<IncidentManagementPage />} />

          </Routes>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
